import { Space } from 'antd';
import clx from 'classnames';
import * as React from 'react';
import styled from 'styled-components';
import { ExpressionReferenceIconOnly } from '../ExpressionReferenceIcon';
import { IReference } from '../IReference';

export interface IReferenceBadgeProps {
  /**
   * La `IReference` da mostrare.
   */
  reference: IReference;
  selected?: boolean;
}

const $ReferenceSpace = styled(Space)`
  border-radius: 4px;
  padding: 0px 6px;
  max-height: 36px;

  &.selected {
    color: black;
    background-color: transparent;
  }

  &.reference--widget {
    background-color: ${({ theme }) => theme.blue1};
    &.selected {
      background-color: ${({ theme }) => theme.blue3};
    }
  }

  &.reference--virtualColumn {
    background-color: ${({ theme }) => theme['cyan-1']};
    &.selected {
      background-color: ${({ theme }) => theme['cyan-3']};
    }
  }

  &.reference--session {
    background-color: ${({ theme }) => theme['magenta-1']};
    &.selected {
      background-color: ${({ theme }) => theme['magenta-3']};
    }
  }

  &.reference--sample {
    background-color: ${({ theme }) => theme.yellow1};
    &.selected {
      background-color: ${({ theme }) => theme.yellow3};
    }
  }

  &.reference--register {
    background-color: ${({ theme }) => theme['green-1']};
    &.selected {
      background-color: ${({ theme }) => theme['green-3']};
    }
  }

  &.reference--semanticFields {
    background-color: ${({ theme }) => theme['purple-2']};
  }
`;

/**
 * Mostra un "Badge" compatto per rappresentare una `IReference`.
 */
export function ReferenceBadge(props: IReferenceBadgeProps) {
  const { reference } = props;

  return (
    <$ReferenceSpace
      className={clx(`reference--${reference.type}`, {
        selected: props.selected,
      })}
    >
      <ExpressionReferenceIconOnly reference={reference} />
      <span>{reference.label}</span>
    </$ReferenceSpace>
  );
}
